import axios from "axios";
import React, { useEffect, useState } from "react";
import { store_availability_fields } from "../data";
import { GlobalState } from "context/GlobalContext";
import { Box, Divider, Typography } from "@mui/material";
import { inputTypes, selectOptKeyName } from "data/globalData";
import RenderInputField from "components/MboPaymentWorking/CommonComponents/RenderInputFiled/RenderInputFiled";

function StoreAvailabilitySection({ value, setValue }) {
	const [filterColumns, setFilterColumns] = useState(store_availability_fields);
	const { setSnackBar, snackBar, setLoadingOpen } = GlobalState();

	const fetchDropdows = async () => {
		// fetch all dropdown values using Promises
		setLoadingOpen(true);
		try {
			await axios.get("/api/mbo_payment_working/get_mbo_stores_and_distributers").then((res) => {
				setFilterColumns((allColumns) => {
					let obj = res.data;
					return allColumns.map((row) => {
						if (obj[row.key] && [inputTypes.SELECT.key, inputTypes.MULTIPLE_SELECT.key].includes(row?.input_type)) {
							let opt = row[selectOptKeyName] ? row[selectOptKeyName] : {};
							opt = { ...opt, list: obj[row.key] };
							return { ...row, [selectOptKeyName]: opt };
						} else return row;
					});
				});
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBar({
				...snackBar,
				message: `failed to load Dropdowns`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	useEffect(() => {
		fetchDropdows();
	}, []);

	return (
		<Box pl={2} width="90%">
			<Box display="flex" columnGap={"2%"} rowGap="10px" flexWrap="wrap">
				{filterColumns?.map((row) => {
					return (
						<RenderInputField
							column={row}
							data={value}
							setData={setValue}
							width="49%"
							selectOptObjName={"select_options"}
							key={row.key}
						/>
					);
				})}
			</Box>
		</Box>
	);
}

export default StoreAvailabilitySection;
